// @generated
// This file is automatically generated by Kanel. Do not modify manually.

import { userId, type UserId } from './User';
import type { ColumnType, Selectable, Insertable, Updateable } from 'kysely';
import { z } from 'zod';

/** Identifier type for public.user_secret */
export type UserSecretId = string & { __brand: 'public.user_secret' };

/** Represents the table public.user_secret */
export default interface UserSecretTable {
  id: ColumnType<UserSecretId, UserSecretId | undefined, UserSecretId>;

  user_id: ColumnType<UserId, UserId, UserId>;

  secret: ColumnType<string, string, string>;

  _created_at: ColumnType<string, string | undefined, string>;
}

export type UserSecret = Selectable<UserSecretTable>;

export type NewUserSecret = Insertable<UserSecretTable>;

export type UserSecretUpdate = Updateable<UserSecretTable>;

export const userSecretId = z.string() as unknown as z.Schema<UserSecretId>;

export const userSecret = z.object({
  id: userSecretId,
  user_id: userId,
  secret: z.string(),
  _created_at: z.string(),
}) as unknown as z.Schema<UserSecret>;

export const userSecretInitializer = z.object({
  id: userSecretId.optional(),
  user_id: userId,
  secret: z.string(),
}) as unknown as z.Schema<UserSecretInitializer>;

export const userSecretMutator = z.object({
  id: userSecretId.optional(),
  user_id: userId.optional(),
  secret: z.string().optional(),
}) as unknown as z.Schema<UserSecretMutator>;
